/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { KvStore } from "@tivocorp/sage-web-sdk/api";

/**
 * In-memory fallback implementation of {@link KvStore}.
 *
 * Used when IndexedDB is unavailable (private browsing, SmartTV storage
 * restrictions, quota exhaustion). Values are not persisted across page reloads.
 */
export class InMemoryKvStore implements KvStore {
  private readonly map = new Map<string, string>();

  async getString(key: string): Promise<string | null> {
    const value = this.map.get(key);
    return value === undefined ? null : value;
  }

  async putString(key: string, value: string): Promise<void> {
    this.map.set(key, value);
  }

  async remove(key: string): Promise<void> {
    this.map.delete(key);
  }
}
